<div
  class="text-center {{ bottom }}"
  [ngClass]="top">
  <img
    src="assets/images/spinner.png"
    class="rot"
    [style.width]="width + 'px'"
    [style.height]="height + 'px'"
    alt="spinner" />
  <h3 *ngIf="text?.length">
    {{ text }}
  </h3>
</div>
